import React from 'react';
import { Text, colorMap } from '../../../../globalStyles';
import styled from 'styled-components';
import * as Styles from '../Styles';

export const ErrorState = ({ message }: { message: string }) => {
  return (
    <Styles.AvailabilitySection>
      <SaveErrorContainer>
        <Text.body>{message}</Text.body>
      </SaveErrorContainer>
    </Styles.AvailabilitySection>
  );
};

const SaveErrorContainer = styled.div`
  padding: 0.75rem 1rem;
  background: ${colorMap.danger[6]};
  border-radius: 4px;
  color: ${colorMap.danger[1]};
`;
